import SUGGESTION_RESPONSE from "./suggestionResponseTypes";

const initialState = {
  loading: true,
  data: [],
  errorMsg: "",
};

const suggestionResponseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUGGESTION_RESPONSE.FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SUGGESTION_RESPONSE.FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: "",
      };
    case SUGGESTION_RESPONSE.FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default suggestionResponseReducer;
